module.exports = __webpack_public_path__ + "media/iconic/loop-circular-95264fcd.svg";